var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeilRunter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-runter__Icn/40px/Pfeil-runter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-runter__Icn/20px/Icon-Platzhalter-Transparent",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-runter__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8786797,16.1213203 L23.8786797,23.8786797 L16.1213203,23.8786797 L16.1213203,16.1213203 L23.8786797,16.1213203 Z M21.8786797,18.1213203 L16.1213203,18.1213203 L16.1213203,23.8786797 L21.8786797,23.8786797 L21.8786797,18.1213203 Z",
    id: ".._.._src_svg_Icn_40px_Pfeil-runter__Rectangle-Copy",
    transform: "scale(1 -1) rotate(-45 -28.284 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilRunter);
export default __webpack_public_path__ + "static/media/Pfeil-runter.7cb8c27f560c69162ab717508d6cb0e3.svg";
export { ForwardRef as ReactComponent };